import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../ui/Button'
import WarningModal from './WarningModal'

const BODY_CLASS = 'tw:m-0! tw:text-base tw:text-gray-500 tw:text-center'

const DEFAULT_MESSAGE = 'Les modifications apportées aux statuts ne seront pas sauvegardées.'

const DiscardChangesModal = ({ isOpen, onCancel, onConfirm, message = DEFAULT_MESSAGE }) => {
  const footer = (
    <>
      <Button variant="neutral" onClick={onCancel}>Continuer l’édition</Button>
      <Button variant="destructive" onClick={onConfirm}>Annuler les modifications</Button>
    </>
  )

  return (
    <WarningModal footer={footer} isOpen={isOpen} title="Abandonner les modifications ?" onClose={onCancel}>
      <p className={BODY_CLASS}>{message}</p>
    </WarningModal>
  )
}

DiscardChangesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

DiscardChangesModal.defaultProps = {
  message: DEFAULT_MESSAGE
}

export default DiscardChangesModal
